import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import moment from "moment";
import MonthInput from "./MonthInput";
import DayInput from "./DayInput";
import YearInput from "./YearInput";
import CheckboxInput from "./CheckboxInput";
import WizardFooter from "./WizardFooter";
import sealImage from "../assets/images/USDOL_Seal.png";
import SignatureModal from "./SignatureModal";
import EnglishWarningModal from "./EnglishWarningModal";
import AlmostDoneModal from "./AlmostDoneModal";
import TextInput from "./TextInput";

export const fields = [
  "access_key_id",
  "benefits_city_and_state",
  "benefits_recipient",
  "birthDay",
  "birthMonth",
  "birthYear",
  "city",
  "convicted_of_felony",
  "conviction_state",
  "convictionMonth",
  "convictionYear",
  "county",
  "court_city_or_county",
  "dischargeMonth",
  "dischargeYear",
  "dol1",
  "dol_signature",
  "dol_signature_statement",
  "dolSignatureDay",
  "dolSignatureMonth",
  "dolSignatureYear",
  "email",
  "first_name",
  "has_been_unemployed",
  "has_received_unemployment_compensation",
  "irs1",
  "irs2",
  "irs3",
  "irs4",
  "irs5",
  "irs6",
  "irs7",
  "irs_signature",
  "irs_signature_statement",
  "irsSignatureDay",
  "irsSignatureMonth",
  "irsSignatureYear",
  "is_entitled_to_compensation",
  "is_veteran",
  "job_description",
  "last_name",
  "officer_name",
  "officer_phone",
  "phone",
  "referred_by_ticket_to_work",
  "referred_by_veterans_affairs",
  "referred_by_vocal_rehab",
  "releaseMonth",
  "releaseYear",
  "service_branch",
  "snap_one_year",
  "snap_six_months",
  "ssn",
  "state",
  "state_or_federal_conviction",
  "street",
  "summary_signature",
  "summary_signature_statement",
  "summarySignatureDay",
  "summarySignatureMonth",
  "summarySignatureYear",
  "supplemental_security_income",
  "tanf_three_years",
  "unemployed_four_weeks",
  "unemployed_six_months",
  "unemployment_state",
  "unemploymentStartDay",
  "unemploymentStartMonth",
  "unemploymentStartYear",
  "work_release",
  "contact_felony",
  "contact_felony_statement",
  "worked_for_us_before",
  "zip",
  "starting_pay",
];

const validate = values => {
  const errors = {};
  if (!values.dol_signature) {
    errors.dol_signature = "Signature required";
  }
  return errors;
};

export class WizardFormETA9175 extends Component {
  state = {
    showAlmostDone: true,
    formEnglishOverride: false,
    showEnglishWarning: false,
    showSignature: false,
  };

  componentDidMount() {
    const {
      fields: {
        has_been_unemployed,
        has_received_unemployment_compensation,
        dol1,
      },
    } = this.props;

    dol1.autofill(
      has_been_unemployed.value === "true" &&
        has_received_unemployment_compensation.value === "true"
    );
  }

  closeAlmostDone = () => {
    this.setState({ showAlmostDone: false });
  };

  closeEnglishWarning = () => {
    this.setState({ showEnglishWarning: false });
  };

  switchToEnglish = () => {
    this.setState({
      showEnglishWarning: false,
      formEnglishOverride: true,
      showSignature: true,
    });
  };

  closeSignature = () => {
    this.setState({
      showSignature: false,
      formEnglishOverride: false,
    });
  };

  openSignature = () => {
    if (this.props.language === "english") {
      this.setState({ showSignature: true });
    } else {
      this.setState({ showEnglishWarning: true });
    }
  };

  getText = () => {
    const { allText } = this.props;
    return { ...allText.shared, ...allText.dol, ...allText };
  };

  getFormText = () => {
    const { allText, allTextEnglish } = this.props;
    const formAllText = this.state.formEnglishOverride
      ? allTextEnglish
      : allText;
    return {
      ...formAllText.shared,
      ...formAllText.dol,
      ...formAllText,
    };
  };

  render() {
    const {
      fields: {
        first_name,
        last_name,
        birthDay,
        birthMonth,
        birthYear,
        ssn,
        unemploymentStartMonth,
        unemploymentStartDay,
        unemploymentStartYear,
        unemployment_state,
        dol1,
        dol_signature,
        dolSignatureDay,
        dolSignatureMonth,
        dolSignatureYear,
        dol_signature_statement,
      },
      handleSubmit,
      previousPage,
    } = this.props;
    const text = this.getText();
    const formText = this.getFormText();
    const progress = 2;
    const buildBirthday = ({ birthYear, birthMonth, birthDay }) =>
      moment(`${birthYear.value}-${birthMonth.value}-${birthDay.value}`);
    const birthMoment = buildBirthday({ birthYear, birthMonth, birthDay });

    return (
      <form onSubmit={handleSubmit} className="form-horizontal">
        <div className="wizard-page-content summary dol">
          <div className="row form-header">
            <div className="col-sm-2">
              <img src={sealImage} />
            </div>
            <div className="col-sm-5">
              <div>{formText.usdol}</div>
              <div>{formText.eta}</div>
            </div>
            <div className="col-sm-5">
              <div>{"OMB Control No. 1205-0371"}</div>
              <div>
                {formText.expirationDate}
                {": May 31, 2026"}
              </div>
            </div>
            <div className="col-12 col-sm-10 offset-sm-2">
              <div>{formText.subtitle}</div>
              <div>{formText.title}</div>
              <div>{formText.title2}</div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 instructions">{formText.instructions}</div>
          </div>

          <div className="row">
            <div className="col">
              <div className="under-penalties">{formText.underPenalties}</div>
            </div>
          </div>

          <div className="row employee-info-summaryIRS">
            <div className="col-12">
              <div>
                <div>
                  {formText.name}
                  {":"}
                </div>
                <div className="employee-value" id="full_name">
                  {first_name.value} {last_name.value}
                </div>
              </div>
            </div>

            <div className="col-sm-9">
              <div>
                <div>
                  {formText.signature}
                  {":"}
                </div>
                <div />
              </div>
            </div>

            <div className="col-sm-3">
              <div>
                <div>
                  {formText.date}
                  {":"}
                </div>
                <div className="employee-value">
                  {moment().format("MMM D, YYYY")}
                </div>
              </div>
            </div>

            <div className="col-12 col-md-8 mt-3">
              <div>
                <div>
                  {formText.ssn}
                  {":"}
                </div>
                <div className="employee-value">{ssn.value}</div>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div>
                <div>
                  {formText.birthDate}
                  {":"}
                </div>
                <div className="employee-value">
                  {birthMoment.format("MMM D, YYYY")}
                </div>
              </div>
            </div>

            <div className="col-12 employers-col">
              <div>
                <div>{formText.employerName0}</div>
                <div className="employee-value">{}</div>
              </div>
            </div>

            <div className="col-12">
              <div>
                <div>{formText.employerName}</div>
                <div className="employee-value">
                  {this.props.employee.location.employer.name}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 check">{formText.check}</div>
          </div>

          <table className="items">
            <tbody>
              <tr>
                <td>
                  <CheckboxInput field={dol1} disabled={false} />
                </td>
                <td>{formText.declaration1}</td>
              </tr>
              <tr />
            </tbody>
          </table>
          <div className="row multistate-declaration">
            <div>{formText.multiStateDeclaration}</div>
            <div className="col-12 col-sm-12 col-md-7 bigger">
              <TextInput text={text} field={unemployment_state} />
            </div>
          </div>
          <div className="col-12">
            <div className="row unemployment-period">
              <div>{formText.declaration2}</div>
              <div className="col-3 col-sm-2 col-md-1">
                <MonthInput text={formText} field={unemploymentStartMonth} />
              </div>
              <div className="col-2 col-sm-1">
                <DayInput
                  text={formText}
                  field={unemploymentStartDay}
                  monthSelected={unemploymentStartMonth}
                  yearSelected={unemploymentStartYear}
                />
              </div>
              <div className="col-3 col-sm-2 col-md-1">
                <YearInput
                  text={formText}
                  field={unemploymentStartYear}
                  monthSelected={unemploymentStartMonth}
                  shouldCheckMonth={true}
                />
              </div>
            </div>
          </div>

          <div className="privacy-act-notice">
            <div>
              <strong>
                {formText.privacyActNoticeLabel}
                {":"}
              </strong>
            </div>
            {formText.privacyActNotice}
          </div>
          <div className="public-burden-statement">
            <div>
              <strong>
                {formText.publicBurdenStatementLabel}
                {":"}
              </strong>
            </div>
            {formText.publicBurdenStatement}
          </div>
          <div className="form-footer">{"ETA Form 9175 (Rev. May 2023)"}</div>
        </div>
        <WizardFooter
          text={formText}
          previousPage={previousPage}
          nextPage={this.openSignature}
          progress={progress}
          previousLabel={formText.startOver}
          nextLabel={formText.sign}
          max={3}
          what={formText.signed}
        />

        <SignatureModal
          showSignature={this.state.showSignature}
          openSignature={this.openSignature}
          closeSignature={this.closeSignature}
          handleSubmit={handleSubmit}
          signatureField={dol_signature}
          signatureDay={dolSignatureDay}
          signatureMonth={dolSignatureMonth}
          signatureYear={dolSignatureYear}
          signatureStatement={dol_signature_statement}
          text={text}
          formText={formText}
          formEnglishOverride={this.state.formEnglishOverride}
        />

        <EnglishWarningModal
          show={this.state.showEnglishWarning}
          close={this.closeEnglishWarning}
          switchToEnglish={this.switchToEnglish}
          text={text}
        />

        <AlmostDoneModal
          show={this.state.showAlmostDone}
          close={this.closeAlmostDone}
          text={text}
        />
      </form>
    );
  }
}

WizardFormETA9175.propTypes = {
  allText: PropTypes.object.isRequired,
  allTextEnglish: PropTypes.object,
  employee: PropTypes.object,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormETA9175);



// WEBPACK FOOTER //
// ./src/components/WizardFormETA9175.js